module.exports = __webpack_public_path__ + "static/media/message_long.mp3?74b0b1472f04bd67808e459c5be24b8f";